function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.36586 4.92823L19.1511 15.902C19.2597 15.9951 19.3476 16.1143 19.4081 16.2504C19.4686 16.3865 19.5 16.5359 19.5 16.6874C19.5 16.8388 19.4686 16.9883 19.4081 17.1244C19.3476 17.2605 19.2597 17.3796 19.1511 17.4728L6.36586 28.4465C6.21838 28.5743 6 28.459 6 28.2502V25.841C6 25.6883 6.0624 25.5418 6.17301 25.4483L16.383 16.6874L6.17301 7.92645C6.06523 7.83295 6 7.68647 6 7.53375V5.12458C5.9998 5.07785 6.0116 5.03201 6.03403 4.99232C6.05647 4.95263 6.08864 4.9207 6.12684 4.9002C6.16505 4.87969 6.20775 4.87144 6.25002 4.8764C6.2923 4.88136 6.33245 4.89932 6.36586 4.92823ZM18.7403 30.4993C18.5004 30.4993 18.3016 30.2224 18.3016 29.8839V28.2716C18.3016 27.9332 18.5004 27.6562 18.7403 27.6562H29.5613C29.8011 27.6562 30 27.9332 30 28.2716V29.8839C30 30.2224 29.8011 30.4993 29.5613 30.4993H18.7403Z",
  fill: "currentColor"
});

var SvgIcSidemenuTesting = function SvgIcSidemenuTesting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSidemenuTesting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_sidemenu_testing.b5f69260.svg";
export { ForwardRef as ReactComponent };